document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.accordion__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
    });
  });

  document.querySelectorAll('[data-bundles]').forEach(function (group) {
    var bundles = group.querySelectorAll('.bundle');
    bundles.forEach(function (b) {
      b.addEventListener('click', function () {
        bundles.forEach(function (x) { x.classList.remove('is-selected'); });
        b.classList.add('is-selected');
        var variantId = b.getAttribute('data-variant-id');
        var input = group.parentElement.querySelector('input[name="id"]');
        if (input && variantId) input.value = variantId;
      });
    });
  });

  document.querySelectorAll('[data-gallery]').forEach(function (gal) {
    var main = gal.querySelector('.product-gallery__main img');
    gal.querySelectorAll('.product-gallery__thumbs button').forEach(function (t) {
      t.addEventListener('click', function () {
        gal.querySelectorAll('.product-gallery__thumbs button').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        if (main && t.getAttribute('data-src')) main.src = t.getAttribute('data-src');
      });
    });
  });

  document.querySelectorAll('.before-after').forEach(function (ba) {
    var after = ba.querySelector('.before-after__after');
    var handle = ba.querySelector('.before-after__handle');
    var dragging = false;
    var setPos = function (x) {
      var rect = ba.getBoundingClientRect();
      var pct = Math.max(0, Math.min(100, ((x - rect.left) / rect.width) * 100));
      after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      handle.style.left = pct + '%';
    };
    var onMove = function (e) {
      if (!dragging) return;
      var x = e.touches ? e.touches[0].clientX : e.clientX;
      setPos(x);
    };
    handle.addEventListener('mousedown', function () { dragging = true; });
    handle.addEventListener('touchstart', function () { dragging = true; });
    document.addEventListener('mouseup', function () { dragging = false; });
    document.addEventListener('touchend', function () { dragging = false; });
    document.addEventListener('mousemove', onMove);
    document.addEventListener('touchmove', onMove, { passive: true });
  });

  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var total = parseInt(el.getAttribute('data-countdown'), 10) || 86400;
    var update = function () {
      var h = String(Math.floor(total / 3600)).padStart(2, '0');
      var m = String(Math.floor((total % 3600) / 60)).padStart(2, '0');
      var s = String(total % 60).padStart(2, '0');
      var hEl = el.querySelector('[data-h]'); if (hEl) hEl.textContent = h;
      var mEl = el.querySelector('[data-m]'); if (mEl) mEl.textContent = m;
      var sEl = el.querySelector('[data-s]'); if (sEl) sEl.textContent = s;
      if (total > 0) total--;
    };
    update();
    setInterval(update, 1000);
  });

  document.querySelectorAll('.marquee__track').forEach(function (track) {
    track.innerHTML += track.innerHTML;
  });
});
